import {
    FaHotel,
    FaMoneyBillWave,
    FaHeadset,
    FaMapMarkedAlt
} from "react-icons/fa";

export default function WhyChooseUs() {
    const features = [
        {
            icon: <FaHotel />,
            number: "01",
            title: "Premium Hotels",
            desc: "Carefully selected luxury hotels and resorts offering exceptional comfort and unforgettable experiences."
        },
        {
            icon: <FaMoneyBillWave />,
            number: "02",
            title: "Best Price Guarantee",
            desc: "Enjoy competitive pricing and exclusive hotel deals with no hidden charges."
        },
        {
            icon: <FaHeadset />,
            number: "03",
            title: "24/7 Customer Support",
            desc: "Our travel specialists are available around the clock to assist with bookings and inquiries."
        },
        {
            icon: <FaMapMarkedAlt />,
            number: "04",
            title: "Top Dubai Locations",
            desc: "Stay close to Dubai's most popular attractions, beaches, shopping malls and business hubs."
        }
    ];

    return (
        <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24 bg-[#001925]">

            {/* Background Decorations */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-[#174B5F]/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>

            <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A83F]/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

            <div className="absolute inset-0 opacity-[0.035]">
                <div
                    className="w-full h-full"
                    style={{
                        backgroundImage:
                            "linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)",
                        backgroundSize: "50px 50px"
                    }}
                ></div>
            </div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Heading */}
                <div className="max-w-3xl mx-auto text-center mb-14 lg:mb-16">

                    {/* Label */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 backdrop-blur-md mb-5">
                        <span className="w-2 h-2 rounded-full bg-[#D4A83F]"></span>

                        <span className="text-xs sm:text-sm font-bold tracking-wide text-white/90">
                            WHY BOOK WITH US
                        </span>
                    </div>

                    {/* Heading */}
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold !text-white leading-tight">
                        Travel Smarter.
                        <span className="block text-[#D4A83F]">
                            Stay Better.
                        </span>
                    </h2>

                    {/* Description */}
                    <p className="max-w-2xl mx-auto mt-5 text-sm sm:text-base text-slate-300 leading-7">
                        Discover unbeatable hotel deals, trusted accommodation
                        options and dedicated support for a seamless Dubai stay.
                    </p>

                </div>

                {/* Feature Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">

                    {features.map((item, index) => (
                        <div
                            key={index}
                            className="group relative overflow-hidden rounded-3xl bg-white/[0.06] border border-white/10 backdrop-blur-xl p-6 sm:p-7 hover:bg-white/[0.10] hover:border-[#D4A83F]/40 hover:-translate-y-2 transition-all duration-500"
                        >

                            {/* Number */}
                            <div className="absolute top-5 right-5">
                                <span className="text-4xl font-black text-white/[0.07] group-hover:text-[#D4A83F]/20 transition-colors duration-500">
                                    {item.number}
                                </span>
                            </div>

                            {/* Icon */}
                            <div className="relative w-14 h-14 rounded-2xl bg-white/10 border border-white/10 text-[#D4A83F] flex items-center justify-center mb-7 group-hover:bg-[#D4A83F] group-hover:text-[#002B45] group-hover:scale-105 transition-all duration-400">
                                <span className="text-xl">
                                    {item.icon}
                                </span>
                            </div>

                            {/* Small Accent */}
                            <div className="flex items-center gap-2 mb-3">
                                <span className="w-6 h-[2px] bg-[#D4A83F] group-hover:w-10 transition-all duration-300"></span>

                                <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-400">
                                    {item.number}
                                </span>
                            </div>

                            {/* Title */}
                            <h3 className="text-lg sm:text-xl font-bold text-white mb-3 group-hover:text-[#D4A83F] transition-colors duration-300">
                                {item.title}
                            </h3>

                            {/* Description */}
                            <p className="text-sm text-slate-400 leading-6">
                                {item.desc}
                            </p>

                            {/* Bottom Accent */}
                            <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#D4A83F] to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>

                        </div>
                    ))}

                </div>

                {/* Bottom Trust Bar */}
                <div className="mt-10 lg:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center">

                    <div className="flex items-center gap-2 text-slate-300 text-sm">
                        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#D4A83F]/10 text-[#D4A83F]">
                            ✓
                        </span>
                        Trusted Hotel Selection
                    </div>

                    <div className="hidden sm:block w-1 h-1 rounded-full bg-slate-600"></div>

                    <div className="flex items-center gap-2 text-slate-300 text-sm">
                        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#D4A83F]/10 text-[#D4A83F]">
                            ✓
                        </span>
                        Secure Booking Experience
                    </div>

                    <div className="hidden sm:block w-1 h-1 rounded-full bg-slate-600"></div>

                    <div className="flex items-center gap-2 text-slate-300 text-sm">
                        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#D4A83F]/10 text-[#D4A83F]">
                            ✓
                        </span>
                        Dedicated Travel Support
                    </div>

                </div>

            </div>
        </section>
    );
}